import { NgModule } from 'ng-metadata/core';
import { CheckoutAccountComponent } from './account.component';

@NgModule({
  declarations: [
    CheckoutAccountComponent,
  ],
})
export class CheckoutAccountModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/account/account.module.ts